import _ from 'lodash'
import { createAction, createReducer } from 'redux-act'
import { baseUrl } from '../scripts/env';
import axios from 'axios'
import { getUser } from './app'

const REDUCER = 'summary'
const NS = `@@${REDUCER}/`

const initialState = {
    stat: {
        isLoading: false,
        payload: {
            income: 0,
            total_reward: 0,
            payed_reward: 0,
            balance: 0
        }
    },
    level: {
        isLoading: false,
        payload: {
            title: '',
            step: 1,
            discount: 0,
            income: 0,
            next_status_left: 0,
            payed_reward: 0,
            sites_count: 0
        }
    },
    chart: {
        isLoading: false,
        chart_data: []
    }
}


export const fetchStatRequest = createAction(`${NS}FETCH_STAT_REQUEST`)
export const fetchStatSuccess = createAction(`${NS}FETCH_STAT_SUCCESS`)
export const fetchStatFailure = createAction(`${NS}FETCH_STAT_FAILURE`)
export const fetchStat = () => async (dispatch) => {
    dispatch(fetchStatRequest())
    const response = await axios({
        url: `${baseUrl}/${REDUCER}/stat`
    });
  
    const stat = _.pick(response.data, _.keys(initialState.stat.payload))
    if (_.isEmpty(stat)) {
        dispatch(fetchStatFailure())
        return false
    }
    
    dispatch(fetchStatSuccess(stat))
    
    return true
}


export const fetchLevelRequest = createAction(`${NS}FETCH_LEVEL_REQUEST`)
export const fetchLevelSuccess = createAction(`${NS}FETCH_LEVEL_SUCCESS`)
export const fetchLevelFailure = createAction(`${NS}FETCH_LEVEL_FAILURE`)
export const fetchLevel = () => async (dispatch) => {
    dispatch(fetchLevelRequest())
    const response = await axios({
        url: `${baseUrl}/${REDUCER}/level`
    });
  
    const level = _.pick(response.data, _.keys(initialState.level.payload))
    if (_.isEmpty(level)) {
        dispatch(fetchLevelFailure())
        return false
    }
    
    dispatch(fetchLevelSuccess(level))
    dispatch(getUser())
    return true
}


export const fetchChartRequest = createAction(`${NS}FETCH_CHART_REQUEST`)
export const fetchChartSuccess = createAction(`${NS}FETCH_CHART_SUCCESS`)
export const fetchChartFailure = createAction(`${NS}FETCH_CHART_FAILURE`)
export const fetchChart = () => async (dispatch) => {
    dispatch(fetchChartRequest())
    const response = await axios({
        url: `${baseUrl}/${REDUCER}/chart`
    });
  
    const chart_data = _.get(response.data, 'chart_data', [])
    if (_.isEmpty(chart_data)) {
        dispatch(fetchChartFailure())
        return false
    }
    
    dispatch(fetchChartSuccess(chart_data))
    return true
}

export default createReducer(
  { 
    [fetchStatRequest]: (state)         => ({ ...state, stat: { ...state.stat, isLoading: true }}),
    [fetchStatSuccess]: (state, payload)   => ({ ...state, stat: { payload, isLoading: false }}),
    [fetchStatFailure]: (state)         => ({ ...state, stat: { ...state.stat, isLoading: false }}),

    [fetchLevelRequest]: (state)        => ({ ...state, level: { ...state.level, isLoading: true }}),
    [fetchLevelSuccess]: (state, payload) => ({ ...state, level: { payload, isLoading: false }}),
    [fetchLevelFailure]: (state)        => ({ ...state, level: { ...state.level, isLoading: false }}),

    [fetchChartRequest]: (state)        => ({ ...state, chart: { ...state.chart, isLoading: true }}),
    [fetchChartSuccess]: (state, chart_data) => ({ ...state, chart: { chart_data, isLoading: false }}),
    [fetchChartFailure]: (state)        => ({ ...state, chart: { ...state.chart, isLoading: false }}),
  },
  initialState
)



// WEBPACK FOOTER //
// ./src/ducks/summary.js